const test_products = [
  {
    group: 'Packages',
    category: 'package',
    name: 'Starter Package - Monthly',
    plan: 'plan_FsTQ1ZRGfLUKs7',
    price: 550
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Growth Package - Monthly',
    plan: 'plan_FsTQutuxaqPPiJ',
    price: 775
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Enterprise Package - Monthly',
    plan: 'plan_FsTQ9i6IQ9ajrC',
    price: 1200
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Starter Package - Annual',
    plan: 'plan_FsVO6pNe3me02F',
    price: 6600
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Growth Package - Annual',
    plan: 'plan_FsVOHfsaTu3VBe',
    price: 9300
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Enterprise Package - Annual',
    plan: 'plan_FsVOISShW0Z7Uc',
    price: 14400
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier I - Monthly',
    plan: 'plan_Dv2FqhW49dSh4r',
    price: 349
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier II - Monthly',
    plan: 'plan_Dv2FQluOLsCOWt',
    price: 599
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier III - Monthly',
    plan: 'plan_Dv2Fehs3dkzOPS',
    price: 999
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier IV - Monthly',
    plan: 'plan_Dv2GhKZxhUU7ho',
    price: 1599
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier I - Annual',
    plan: 'plan_Dv2GN4cDiZarnj',
    price: 4188
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier II - Annual',
    plan: 'plan_Dv2GzmcSnLuqfd',
    price: 7188
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier III - Annual',
    plan: 'plan_Dv2GDfJmtz7fur',
    price: 11988
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier IV - Annual',
    plan: 'plan_Dv2HH9FXqMCO8X',
    price: 19188
  },

  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier I - Monthly',
    plan: 'plan_Dv2H0QvvZpPlAE',
    price: 300
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier II - Monthly',
    plan: 'plan_Dv2HvaFbwhnvOv',
    price: 450
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier III - Monthly',
    plan: 'plan_Dv2IHhA2Kldk0R',
    price: 600
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier IV - Monthly',
    plan: 'plan_Dv2IdwkxHnRjNA',
    price: 1000
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier V - Monthly',
    plan: 'plan_Dv2IGNGNfBLPdi',
    price: 1800
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier I - Annual',
    plan: 'plan_Dv2IiTPByLlXdR',
    price: 3600
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier II - Annual',
    plan: 'plan_Dv2I0R6E3U740r',
    price: 5400
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier III - Annual',
    plan: 'plan_Dv2JmQ1BchIcYJ',
    price: 7200
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier IV - Annual',
    plan: 'plan_Dv2J8vn1ulztPW',
    price: 12000
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier V - Annual',
    plan: 'plan_Dv2JhMOXnNcwee',
    price: 21600
  },

  {
    group: 'LTC Quoter',
    category: 'ltc_quoters',
    name: 'Tier I - Monthly',
    plan: 'plan_test_change_later',
    price: 3
  },

  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier I - Monthly',
    plan: 'plan_Dv2Ot2bECqgT8Y',
    price: 200
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier II - Monthly',
    plan: 'plan_Dv2Oeh5RatB9qy',
    price: 400
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier III - Monthly',
    plan: 'plan_Dv2Pt7yLSx9QP6',
    price: 800
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier IV - Monthly',
    plan: 'plan_Dv2PPkSBiC0JFT',
    price: 1200
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier I - Annual',
    plan: 'plan_Dv2PkGbabWRSA4',
    price: 2400
  },

  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier I - Monthly',
    plan: 'plan_Dv2KVUpLkahLuI',
    price: 300
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier II - Monthly',
    plan: 'plan_Dv2KT42YGUgNhs',
    price: 600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier III - Monthly',
    plan: 'plan_Dv2Kbz21F61GjN',
    price: 1200
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier IV - Monthly',
    plan: 'plan_Dv2KVGm1lrZ5L8',
    price: 2400
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier V - Monthly',
    plan: 'plan_Dv2KAp71zNyxF7',
    price: 4800
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier VI - Monthly',
    plan: 'plan_Dv2Kr50pPwRMml',
    price: 9600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier I - Annual',
    plan: 'plan_Dv2L6X12mdZzsh',
    price: 3600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier II - Annual',
    plan: 'plan_Dv2LVJz7qTPEFz',
    price: 7200
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier III - Annual',
    plan: 'plan_Dv2L8DqrFsyV43',
    price: 14400
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier IV - Annual',
    plan: 'plan_Dv2LM6ZLfqlAht',
    price: 28800
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier V - Annual',
    plan: 'plan_Dv2MqI6S8hus91',
    price: 57600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier VI - Annual',
    plan: 'plan_Dv2MKSqrrDstKl',
    price: 115200
  },

  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: 'No Contract - Monthly',
    plan: 'plan_Dv2NWifg6m4Ry7',
    price: 30
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '1 Year Contract - Monthly',
    plan: 'plan_Dv2NoQKh3eC8jI',
    price: 25
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '3 Year Contract - Monthly',
    plan: 'plan_Dv2OrlHKKmMjQl',
    price: 22.5
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '1 Year Contract - Annual',
    plan: 'plan_Dv2OsPE9t87Onv',
    price: 300
  },

  {
    group: 'Website',
    category: 'websites',
    name: 'Agency - Monthly',
    plan: 'plan_DywgkYmPIZJr8r',
    price: 99
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agent - Monthly',
    plan: 'plan_DywgnLpItR2ozU',
    price: 35
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agency - Annual',
    plan: 'plan_DywhguW1wVuqJQ',
    price: 1188
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agent - Annual',
    plan: 'plan_DywgXPwDbBf3RY',
    price: 420
  }
];

const live_products = [
  {
    group: 'Packages',
    category: 'package',
    name: 'Starter Package - Monthly',
    plan: 'plan_FsWIBhr92h7i5D',
    price: 550
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Growth Package - Monthly',
    plan: 'plan_FsWI2QlGmt5sqS',
    price: 775
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Enterprise Package - Monthly',
    plan: 'plan_FsWIu3pN33AoK1',
    price: 1200
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Starter Package - Annual',
    plan: 'plan_FsWIxRFLjFRLJo',
    price: 6600
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Growth Package - Annual',
    plan: 'plan_FsWJXtwsARVuel',
    price: 9300
  },
  {
    group: 'Packages',
    category: 'package',
    name: 'Enterprise Package - Annual',
    plan: 'plan_FsWJdo2hiV9Ag0',
    price: 14400
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier I - Monthly',
    plan: 'Mobile App Tier 1 hosting/support',
    price: 349
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier II - Monthly',
    plan: 'plan_CrXYPkZCbyYVhs',
    price: 599
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier III - Monthly',
    plan: 'plan_CrXY4j5rO8wI5H',
    price: 999
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier IV - Monthly',
    plan: 'plan_CrXZt7rY2j0ZrP',
    price: 1599
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier I - Annual',
    plan: 'plan_Cudqco9n5zdCGM',
    price: 4188
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier II - Annual',
    plan: 'plan_Cudv4GCecJ3VnM',
    price: 7188
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier III - Annual',
    plan: 'plan_CudvmtsXNCbhAd',
    price: 11988
  },
  {
    group: 'Mobile App',
    category: 'mobile_apps',
    name: 'Tier IV - Annual',
    plan: 'plan_CudwXP7nuoBgHy',
    price: 19188
  },

  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier I - Monthly',
    plan: 'plan_CrXIWL9jKQ8VWG',
    price: 300
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier II - Monthly',
    plan: 'plan_CrXKK1x90l8wh6',
    price: 450
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier III - Monthly',
    plan: 'plan_CrXM0MIWGAqeqk',
    price: 600
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier IV - Monthly',
    plan: 'plan_CrXNj2nKLjSjpZ',
    price: 1000
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier V - Monthly',
    plan: 'plan_CrXNGPwqwGq8Nt',
    price: 1800
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier I - Annual',
    plan: 'plan_CrYp3gRRwmCEQn',
    price: 3600
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier II - Annual',
    plan: 'plan_CudyzL9QiCui9W',
    price: 5400
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier III - Annual',
    plan: 'plan_Cudz0uio9XtMJG',
    price: 7200
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier IV - Annual',
    plan: 'plan_Cue0scV4SMEbrG',
    price: 12000
  },
  {
    group: 'Agency Life Quoter',
    category: 'bga_quoters',
    name: 'Tier V - Annual',
    plan: 'plan_Cue18iwWhsCFD3',
    price: 21600
  },

  {
    group: 'LTC Quoter',
    category: 'ltc_quoters',
    name: 'Tier I - Monthly',
    plan: 'plan_test_change_later',
    price: 3
  },

  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier I - Monthly',
    plan: 'IXN Carrier Forms Engine',
    price: 200
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier II - Monthly',
    plan: 'plan_CrXSa99aoIGhtk',
    price: 400
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier III - Monthly',
    plan: 'plan_CrXUpbYB3exqJ9',
    price: 800
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier IV - Monthly',
    plan: 'plan_CrXVBhdV7hk0ez',
    price: 1200
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier V - Monthly',
    plan: 'plan_CrXWirUPvT4Xzv',
    price: 2400
  },
  {
    group: 'Forms Engine',
    category: 'form_engines',
    name: 'Tier I - Annual',
    plan: 'plan_CrZ5bdU3dTjnnY',
    price: 2400
  },

  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier I - Monthly',
    plan: 'plan_CrYQgNYsYPMsh2',
    price: 300
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier II - Monthly',
    plan: 'plan_CrYQEpv4LDeb0S',
    price: 600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier III - Monthly',
    plan: 'plan_CrYRYmiZcy864x',
    price: 1200
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier IV - Monthly',
    plan: 'plan_CrYRR5QcSsXD2R',
    price: 2400
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier V - Monthly',
    plan: 'plan_CrYSBeC3qtO2G7',
    price: 4800
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier VI - Monthly',
    plan: 'plan_CrYSgBI8rBnyWi',
    price: 9600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier I - Annual',
    plan: 'plan_Cue58YV1ZoHRrD',
    price: 3600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier II - Annual',
    plan: 'plan_Cue6qoboCyU0qg',
    price: 7200
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier III - Annual',
    plan: 'plan_Cue6YgAG0I5U8d',
    price: 14400
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier IV - Annual',
    plan: 'plan_CueGnR0zUF1WQY',
    price: 28800
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier V - Annual',
    plan: 'plan_CueGuLS3pc6moo',
    price: 57600
  },
  {
    group: 'API Client',
    category: 'api_clients',
    name: 'Tier VI - Annual',
    plan: 'plan_CueHNSOTUt8zl0',
    price: 115200
  },

  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: 'No Cont - Monthlyract',
    plan: 'IXN_017',
    price: 30
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '1 Year Contract - Monthly',
    plan: 'plan_CrYZZGwS3cHVtF',
    price: 25
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '3 Year Contract - Monthly',
    plan: 'plan_CrYapdMPlux4Jq',
    price: 22.5
  },
  {
    group: 'Website Quoter',
    category: 'website_quoters',
    name: '1 Year Contract - Annual',
    plan: 'plan_CvI34kEjeNPkYa',
    price: 300
  },

  {
    group: 'Website',
    category: 'websites',
    name: 'Agency - Monthly',
    plan: 'plan_CrYjIDsOLqce3q',
    price: 99
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agent - Monthly',
    plan: 'plan_CuecFBC0q9qJuS',
    price: 35
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agency - Annual',
    plan: 'plan_CrYn2m4918wOJi',
    price: 1188
  },
  {
    group: 'Website',
    category: 'websites',
    name: 'Agent - Annual',
    plan: 'Agent Website Annual',
    price: 420
  }
];

export const STRIPE_PRODUCTS =
  process.env.NODE_ENV === 'production' ? live_products : test_products;
